import React from "react";
import { categoryAccentColor } from "../uiUtils";

// Category tiles. The category's own colour is a left SPINE rather than a top border or a background
// wash: a spine survives any tile size, keeps text contrast intact, and gives the eye a colour rail
// to scan down — which is how a cashier finds a category without reading every label.
export default function CategoryGrid({ categories, onSelect }) {
  if (!categories || categories.length === 0) return <div className="qv-empty">No categories</div>;
  return (
    <div className="qv-cats">
      {categories.map((c, i) => {
        const name = c.cat_name || c.title || "Category";
        return (
          <button
            key={c.id}
            type="button"
            className="qv-cat"
            style={{ "--spine": categoryAccentColor(c.color, c.title || c.cat_name, i) }}
            onClick={() => onSelect(c)}
            title={name}
          >
            <span className="qv-cat-name">{name}</span>
          </button>
        );
      })}
    </div>
  );
}
